export default {
    en: {
        id: 'diagram3b4-4',
        blocks: [
            {
                task: 'S = Hoped to offset unexpected earnings decline with additional $10b cut in operating costs.',
                answer: 'Hoped to get X by doing Y',
                title: "S = ",
                modelName: 's'
            },
            {
                task: 'C = But related short-term increases in operating costs also likely, meaning must instead look for savings in fixed costs (difficult to get at)',
                answer: 'Won’t work, need Z instead',
                title: "C = ",
                modelName: 'c'
            },
            {
                task: 'Q = (Can we realistically expect to cut $10b from our fixed costs?',
                answer: 'Will it work?',
                title: "Q = ",
                modelName: 'q'
            },
            {
                task: 'A = Yes'
            }
        ],
        subtitle: 'Fill in the SCQ boxes substituting Xs and Ys, etc. for specific nouns. Then press "simplest structure" and compare your answers',
        correctAnswers: 3
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4a/practiceInSeeing/i18n/exercise4.js